module.exports = __webpack_public_path__ + "static/img/status.a66e271.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/status.png
// module id = pJaK
// module chunks = 0